class QalaLinkedVariations {
	/**
	 * Constructor.
	 * Fires up our functionality that should always run.
	 */
	constructor() {
		this.targetClassImageBox = 'js-qala-linked-variations-image-box';
		this.targetClassDropdown = 'js-qala-linked-variations-dropdown';
		this.hiddenClass = 'hidden-text';
		this.shortDescriptionParent = document.querySelector( '.swatch-short-description' );
		this.dropdownElements = document.querySelectorAll( `.${ this.targetClassDropdown }` );

		if ( this.shortDescriptionParent ) {
			this.setupTextEvents();
		}

		if ( this.dropdownElements.length > 0 ) {
			this.setupDropdownEvents();
		}
	}

	/**
	 * Set up event listeners.
	 */
	setupTextEvents = () => {
		const linkedVariations = document.querySelectorAll( '.qala-linked-variations__group' );
		if ( linkedVariations?.length > 0 ) {
			linkedVariations.forEach( linkedVariationGroup => {
				linkedVariationGroup.addEventListener(
					'mouseover',
					event => {
						this.hoveringLinkedVariations( event.target );
					}
				);
			} );
		}
	};

	/**
	 * Set up event listeners for dropdowns.
	 *
	 * @since 1.0.0
	 * @return {void}
	 */
	setupDropdownEvents = () => {
		this.dropdownElements.forEach( dropdownElement => {
			dropdownElement.addEventListener( 'change', event => {
				this.redirectToSelectedVariationOption( event.target );
			} );
		} );
	}

	redirectToSelectedVariationOption = target => {
		if ( ! target.classList.contains( this.targetClassDropdown ) ) {
			return;
		}

		const selectedOption = target.options[ target.selectedIndex ];
		const selectedOptionValue = selectedOption.value;

		if ( selectedOptionValue ) {
			window.location.href = selectedOptionValue;
		}
	}

	/**
	 * Hovering a linked variation group.
	 *
	 * Lets show the short product name if possible.
	 *
	 * @param {HTMLElement} target The target.
	 */
	hoveringLinkedVariations = target => {
		if ( ! target.classList.contains( this.targetClassImageBox ) ) {
			return;
		}

		// Get the short description and empty it.
		const variationGroup = target.closest( '.qala-linked-variations__group' );
		const shortDescriptionParent = variationGroup.querySelector( '.swatch-short-description' );
		shortDescriptionParent.innerHTML = '';

		const shortProductName = target?.dataset?.shortProductName;
		if ( shortProductName ) {
			shortDescriptionParent.classList.remove( this.hiddenClass );
			shortDescriptionParent.innerHTML = shortProductName;
		} else {
			shortDescriptionParent.classList.add( this.hiddenClass );
		}
	};
}

// Run our class once dom content is loaded.
document.addEventListener( 'DOMContentLoaded', () => {
	new QalaLinkedVariations();
} );
